import React from 'react';
import { Icon, IconName } from '../../components/icons';

export type PaymentState = 'paid' | 'unpaid' | 'ignored';

const META: Record<PaymentState, { icon: IconName; label: string }> = {
    paid: { icon: 'check', label: 'Wpłacono' },
    unpaid: { icon: 'x', label: 'Brak wpłaty' },
    ignored: { icon: 'minus', label: 'Zwolniony z płatności' },
};

/**
 * Payment status as shape + colour (tick / cross / dash), so it stays readable
 * for colour-blind users and in greyscale prints. Becomes a button when `onClick` is given.
 */
export const StatusBadge: React.FC<{
    state: PaymentState;
    size?: 'md' | 'sm';
    onClick?: () => void;
    disabled?: boolean;
    title?: string;
    ariaLabel?: string;
}> = ({ state, size = 'md', onClick, disabled, title, ariaLabel }) => {
    const { icon, label } = META[state];
    const className = `status-badge ${state}${size === 'sm' ? ' sm' : ''}`;
    const glyph = <Icon name={icon} size={size === 'sm' ? 14 : 18} />;
    if (onClick) {
        return (
            <button type="button" className={className} onClick={onClick} disabled={disabled} title={title || label} aria-label={ariaLabel || label}>
                {glyph}
            </button>
        );
    }
    return (
        <span className={className} role="img" aria-label={ariaLabel || label} title={title || label}>
            {glyph}
        </span>
    );
};

export const PaymentLegend: React.FC<{ note?: string }> = ({ note }) => (
    <div className="legend" aria-label="Legenda">
        {(Object.keys(META) as PaymentState[]).map(state => (
            <span className="legend-item" key={state}>
                <StatusBadge state={state} size="sm" />
                {META[state].label}
            </span>
        ))}
        {note && <span className="legend-note">{note}</span>}
    </div>
);
